import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Account } from "@faire/web/slate/icons/foundation/Account";
import React from "react";
import { OTHER_NODES_LABEL } from "../../shared/other-node";
import { AccountEmailIA } from "../instantAnswers/myAccount-accountEmail";
import { ApplyForEoriIA } from "../instantAnswers/myAccount-applyForEori";
import { CheckAccountVerificationStatusIA } from "../instantAnswers/myAccount-checkAccountVerificationStatus";
import { ContactInfoIA } from "../instantAnswers/myAccount-contactInfo";
import { DoNotHaveRequestedInfoIA } from "../instantAnswers/myAccount-doNotHaveReuqestedInfo";
import { EmailNotificationsIA } from "../instantAnswers/myAccount-emailNotifications";
import { LinkingPosIA } from "../instantAnswers/myAccount-linkingPos";
import { ManageEoriInfoIA } from "../instantAnswers/myAccount-manageEoriInfo";
import { ManageTeamsIA } from "../instantAnswers/myAccount-manageTeams";
import { MultifactorAuthIA } from "../instantAnswers/myAccount-multifactorAuth";
import { PasswordIA } from "../instantAnswers/myAccount-password";
import { PasswordResetIA } from "../instantAnswers/myAccount-passwordReset";
import { ProvideRequestedInfoIA } from "../instantAnswers/myAccount-provideRequestedInfo";
import { ShippingAddressIA } from "../instantAnswers/myAccount-shippingAddress";
import { TroubleshootingAndOtherPOSIA } from "../instantAnswers/myAccount-troubleshootingAndOtherPos";
import { UnlinkingPosIA } from "../instantAnswers/myAccount-unlinkingPos";
import { UpdateAccountTypeIA } from "../instantAnswers/myAccount-updateAccountType";
import { VatAndTaxIdentifiersIA } from "../instantAnswers/myAccount-vatAndTaxIdentifiers";
import { WhatIsEoriIA } from "../instantAnswers/myAccount-whatIsEori";
import { WhyOrderCancelledIA } from "../instantAnswers/myAccount-whyOrderCancelled";
import { WhyOrderOnHoldIA } from "../instantAnswers/myAccount-whyOrderOnHold";
import { BillingAddressIA } from "../instantAnswers/shared-billingAddress";
import { AccountVerificationPendingVisibilityFn } from "../visibilityFunctions/accountVerificationPendingVisibilityFn";
import { AccountVerificationRejectedVisibilityFn } from "../visibilityFunctions/accountVerificationRejectedVisibilityFn";
import { AccountVerificationVisibilityFn } from "../visibilityFunctions/accountVerificationVisibilityFn";
import { ManageEoriInfoVisibilityFn } from "../visibilityFunctions/manageEoriInfoVisibilityFn";
import { VatAndTaxIdentifiersVisibilityFn } from "../visibilityFunctions/vatAndTaxIdentifiersVisibilityFn";
export var useMyAccountRetailerNodes = function useMyAccountRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    MyAccount: {
      id: "MyAccount",
      label: strictLocalize({
        id: "uB52R5",
        defaultMessage: [{
          "type": 0,
          "value": "A minha conta"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Account, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["AccountVerification", "ManageAccount", "AccountSettings", "PointOfSale"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "KCsrJG",
        defaultMessage: [{
          "type": 0,
          "value": "Problema com a conta"
        }]
      })
    },
    AccountVerification: {
      id: "AccountVerification",
      label: strictLocalize({
        id: "2FcvDg",
        defaultMessage: [{
          "type": 0,
          "value": "Verificação de conta"
        }]
      }),
      children: ["WhyOrderOnHold", "ProvideRequestedInformation", "DoNotHaveRequestedInformation", "CheckAccountVerificationStatus", "WhyOrderCancelled", "OtherAccountVerification"],
      isNodeVisible: AccountVerificationVisibilityFn,
      level: 2
    },
    ManageAccount: {
      id: "ManageAccount",
      label: strictLocalize({
        id: "84Wa06",
        defaultMessage: [{
          "type": 0,
          "value": "Gerir conta"
        }]
      }),
      children: ["AccountEmail", "ManageTeams", "EmailNotifications"],
      level: 2
    },
    AccountSettings: {
      id: "AccountSettings",
      label: strictLocalize({
        id: "uaosyt",
        defaultMessage: [{
          "type": 0,
          "value": "Definições de conta"
        }]
      }),
      children: ["PasswordReset", "MultifactorAuth", "UpdateAccount", "OtherAccountSettings"],
      level: 2
    },
    PointOfSale: {
      id: "PointOfSale",
      label: strictLocalize({
        id: "YW1YgA",
        defaultMessage: [{
          "type": 0,
          "value": "Ponto de venda"
        }]
      }),
      children: ["LinkingPOS", "Troubleshooting", "UnlinkingPOS", "OtherPointOfSale"],
      level: 2
    },
    WhyOrderOnHold: {
      id: "WhyOrderOnHold",
      label: strictLocalize({
        id: "Io1gMg",
        defaultMessage: [{
          "type": 0,
          "value": "Porque está em espera a minha encomenda"
        }]
      }),
      articles: [articles.MyOrders.BUSINESS_PROFILE],
      instantAnswer: WhyOrderOnHoldIA(strictLocalize, articles),
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    ProvideRequestedInformation: {
      id: "ProvideRequestedInformation",
      label: strictLocalize({
        id: "PybJ+h",
        defaultMessage: [{
          "type": 0,
          "value": "Fornecer informações solicitadas"
        }]
      }),
      articles: [articles.Account.ORDER_ISSUE],
      instantAnswer: ProvideRequestedInfoIA(strictLocalize),
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    DoNotHaveRequestedInformation: {
      id: "DoNotHaveRequestedInformation",
      label: strictLocalize({
        id: "FU93LZ",
        defaultMessage: [{
          "type": 0,
          "value": "Não têm as informações solicitadas"
        }]
      }),
      articles: [articles.Account.NOT_OPEN],
      instantAnswer: DoNotHaveRequestedInfoIA(strictLocalize, articles),
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    CheckAccountVerificationStatus: {
      id: "CheckAccountVerificationStatus",
      label: strictLocalize({
        id: "IshNgf",
        defaultMessage: [{
          "type": 0,
          "value": "Consultar o estado de verificação da conta"
        }]
      }),
      articles: [articles.MyOrders.BUSINESS_PROFILE],
      instantAnswer: CheckAccountVerificationStatusIA(strictLocalize, articles),
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    WhyOrderCancelled: {
      id: "WhyOrderCancelled",
      label: strictLocalize({
        id: "3zAjuD",
        defaultMessage: [{
          "type": 0,
          "value": "Porque foi cancelada a minha encomenda"
        }]
      }),
      instantAnswer: WhyOrderCancelledIA(strictLocalize, articles),
      isNodeVisible: AccountVerificationRejectedVisibilityFn,
      level: 3
    },
    OtherAccountVerification: {
      id: "OtherAccountVerification",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.MyOrders.BUSINESS_PROFILE],
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    AccountEmail: {
      id: "AccountEmail",
      label: strictLocalize({
        id: "qzkDIg",
        defaultMessage: [{
          "type": 0,
          "value": "E-mail da conta"
        }]
      }),
      articles: [articles.Account.ACCOUNT_EMAIL],
      instantAnswer: AccountEmailIA(strictLocalize),
      level: 3
    },
    ManageTeams: {
      id: "ManageTeams",
      label: strictLocalize({
        id: "WNGeTn",
        defaultMessage: [{
          "type": 0,
          "value": "Gerir equipas"
        }]
      }),
      articles: [articles.Account.MANAGE_TEAMS],
      instantAnswer: ManageTeamsIA(strictLocalize),
      level: 3
    },
    EmailNotifications: {
      id: "EmailNotifications",
      label: strictLocalize({
        id: "xdH/UZ",
        defaultMessage: [{
          "type": 0,
          "value": "Notificações por e-mail"
        }]
      }),
      articles: [articles.Account.EMAIL_NOTIFICATIONS],
      instantAnswer: EmailNotificationsIA(strictLocalize),
      level: 3
    },
    PasswordReset: {
      id: "PasswordReset",
      label: strictLocalize({
        id: "JBijqh",
        defaultMessage: [{
          "type": 0,
          "value": "Redefinir a palavra-passe"
        }]
      }),
      articles: [articles.FAQ.RESETTING_PASSWORD],
      instantAnswer: PasswordResetIA(strictLocalize),
      level: 3
    },
    MultifactorAuth: {
      id: "MultifactorAuth",
      label: strictLocalize({
        id: "k8NE3+",
        defaultMessage: [{
          "type": 0,
          "value": "Autenticação multifator"
        }]
      }),
      instantAnswer: MultifactorAuthIA(strictLocalize),
      level: 3
    },
    UpdateAccount: {
      id: "UpdateAccount",
      label: strictLocalize({
        id: "FzuD23",
        defaultMessage: [{
          "type": 0,
          "value": "Atualizar conta"
        }]
      }),
      children: ["BillingAddress", "ShippingAddress", "ContactInfo", "EORI", "Password", "VATAndTaxIdentifiers", "UpdateAccountType"],
      level: 3
    },
    OtherAccountSettings: {
      id: "OtherAccountSettings",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.GettingStarted.RESELLER_ID, articles.GettingStarted.BRICK_AND_MORTAR, articles.MyOrders.BUSINESS_PROFILE],
      level: 3
    },
    LinkingPOS: {
      id: "LinkingPOS",
      label: strictLocalize({
        id: "kiznxY",
        defaultMessage: [{
          "type": 0,
          "value": "Associar PDV"
        }]
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: LinkingPosIA(strictLocalize),
      level: 3
    },
    Troubleshooting: {
      id: "Troubleshooting",
      label: strictLocalize({
        id: "LjdkiP",
        defaultMessage: [{
          "type": 0,
          "value": "Resolver problemas"
        }]
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: TroubleshootingAndOtherPOSIA(strictLocalize),
      level: 3
    },
    UnlinkingPOS: {
      id: "UnlinkingPOS",
      label: strictLocalize({
        id: "zvk6PX",
        defaultMessage: [{
          "type": 0,
          "value": "Desassociar PDV"
        }]
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: UnlinkingPosIA(strictLocalize),
      level: 3
    },
    OtherPointOfSale: {
      id: "OtherPointOfSale",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: TroubleshootingAndOtherPOSIA(strictLocalize),
      level: 3
    },
    BillingAddress: {
      id: "BillingAddress",
      label: strictLocalize({
        id: "z5ti4q",
        defaultMessage: [{
          "type": 0,
          "value": "Endereço de faturação"
        }]
      }),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_CHANGE_MY_BILLING_ADDRESS],
      instantAnswer: BillingAddressIA(strictLocalize),
      level: 4
    },
    ShippingAddress: {
      id: "ShippingAddress",
      label: strictLocalize({
        id: "EPdy0V",
        defaultMessage: [{
          "type": 0,
          "value": "Endereço de envio"
        }]
      }),
      articles: [articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: ShippingAddressIA(strictLocalize),
      level: 4
    },
    ContactInfo: {
      id: "ContactInfo",
      label: strictLocalize({
        id: "jkqM2m",
        defaultMessage: [{
          "type": 0,
          "value": "Informações de contacto"
        }]
      }),
      instantAnswer: ContactInfoIA(strictLocalize),
      level: 4
    },
    EORI: {
      id: "EORI",
      label: strictLocalize({
        id: "XT/NsZ",
        defaultMessage: [{
          "type": 0,
          "value": "EORI"
        }]
      }),
      children: ["WhatIsEORI", "ApplyForEORI", "ManageEORI"],
      level: 4
    },
    Password: {
      id: "Password",
      label: strictLocalize({
        id: "5QVTHl",
        defaultMessage: [{
          "type": 0,
          "value": "Palavra-passe"
        }]
      }),
      instantAnswer: PasswordIA(strictLocalize),
      level: 4
    },
    VATAndTaxIdentifiers: {
      id: "VATAndTaxIdentifiers",
      label: strictLocalize({
        id: "b6O3ej",
        defaultMessage: [{
          "type": 0,
          "value": "Números de identificação para efeitos de IVA e fiscais"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.VAT],
      instantAnswer: VatAndTaxIdentifiersIA(strictLocalize),
      isNodeVisible: VatAndTaxIdentifiersVisibilityFn,
      level: 4
    },
    UpdateAccountType: {
      id: "UpdateAccountType",
      label: strictLocalize({
        id: "X8j4jF",
        defaultMessage: [{
          "type": 0,
          "value": "Atualizar o tipo de conta para \"Loja física\""
        }]
      }),
      instantAnswer: UpdateAccountTypeIA(strictLocalize),
      level: 4
    },
    WhatIsEORI: {
      id: "WhatIsEORI",
      label: strictLocalize({
        id: "MxJaAT",
        defaultMessage: [{
          "type": 0,
          "value": "O que é o número EORI"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.EORI],
      instantAnswer: WhatIsEoriIA(strictLocalize),
      level: 5
    },
    ApplyForEORI: {
      id: "ApplyForEORI",
      label: strictLocalize({
        id: "rOQFiK",
        defaultMessage: [{
          "type": 0,
          "value": "Candidate-se para obter o número EORI"
        }]
      }),
      instantAnswer: ApplyForEoriIA(strictLocalize, articles),
      isNodeVisible: ManageEoriInfoVisibilityFn,
      level: 5
    },
    ManageEORI: {
      id: "ManageEORI",
      label: strictLocalize({
        id: "+B5d5l",
        defaultMessage: [{
          "type": 0,
          "value": "Gerir informações EORI"
        }]
      }),
      instantAnswer: ManageEoriInfoIA(strictLocalize),
      isNodeVisible: ManageEoriInfoVisibilityFn,
      level: 5
    }
  };
};